import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';
import EmpresasService from '../../services/empresas.service';


const SelectEmpresas = ({value,disabled,onChange,isClearable,errorText,disabledIds, ...props}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const [selectedValue, setSelectedValue] = useState();
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([]);
    const actualizar = async() =>{
        await EmpresasService.getAll().then((resp)=>{
            if(resp?.length > 0){
                setItems(resp)
            }
        })
    }
    const onSelectValue =
    useMemo(() =>
        (ev) => {
            setSelectedValue(ev)
            if(Array.isArray(ev)){
                onChange(ev.map(e=>{
                    const item = items.find(it=>it.id_emp === e.value);
                    return {
                        ...e,
                        item: item,
                    }
                }));
            } else if(ev){
                ev.item = items.find(it=>it.id_emp === ev.value);
                onChange(ev);
            } else {
                onChange(null);
            }
        }
    , [])

    useEffect(() => {
        if(items?.length > 0){
            const newOptions = items.map((item) => {
                return {
                    value: item.id_emp,
                    label: item.nombre_emp,
                    ...item
                };
            });
            setOptions(newOptions);
            if(disabledIds){
                const filtro = newOptions.filter((op)=> op?.value !== 3)
                setOptions(filtro);
            }
        }
    }, [items,disabledIds]);

    useEffect(() => {
        if( options.length > 0 ){
            if (typeof value === 'string' || typeof value === 'number') {
                setSelectedValue(options.find((opt) => opt.value === value));
            } else if(Array.isArray(value)){
                setSelectedValue(value.map((va)=>{
                const busq = options?.find((it)=> it.value === va)
                    return({
                        label:busq?.label,
                        value:busq?.value,
                        ...busq
                    })
                }))
            }
        }
    }, [options,value])

    useEffect(() => {
        actualizar();
    }, [])

    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : 'gray',
        })
    }), [isDarkMode])

    return (
        <Select
            {...props}
            className='react-select-container'
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder='Seleccione...'
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectEmpresas.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectEmpresas;